import { render, staticRenderFns } from "./SeletorDeLojasDoUsuario.vue?vue&type=template&id=3ad9f28a&"
import script from "./SeletorDeLojasDoUsuario.vue?vue&type=script&lang=ts&"
export * from "./SeletorDeLojasDoUsuario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports